export default "__VITE_ASSET__CRkIOUOi__"